export default "__VITE_ASSET__DX_U_GZv__"